import * as yup from 'yup';

export const schema = yup.object().shape({
  value: yup.number().required('Required field'),
  month: yup.number().required('Required field'),
  year: yup.number().required('Required field'),
  notes: yup.string(),
});
